import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.GATSBY_API_URL,
});

export default apiClient;
